import React, { useEffect, useState, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { addTests } from "../../Redux_Services/slices/testSlice";
import useRiskScoreAssessment from "../../Hooks/SwassariskscoreAssessment";
import { useGeneralTestLogic } from "../../Hooks/DependentTest";

const TB_FIELD_KEYS = new Set(
  ["tb_likely", "tb_risk", "tb_riskscore", "tb_summary"].map((key) =>
    key.toLowerCase()
  )
);

const TB_DISPLAY_ORDER = ["tb_likely", "tb_risk", "tb_riskscore", "tb_summary"];
const TB_PARAMETER_IDS = new Set([
  "GE9223", // TB_LIKELY
  "GE4761", // TB_RISK
  "GE0399", // TB_RISKSCORE
  "GE3903", // TB_SUMMARY
]);




const EXCLUDED_KEYS = new Set(
  [
    "covid_summary",
    "covid_risk_score",
    "covid_risk",
    "assessmentid",
    "patientid",
    "timestamp",
    "userid",
    "status",
  ].map((key) => key.toLowerCase())
);


const subfield2 = [
  {
    _id: "691755caaae85ffdbee92060",
    name: "COUGH_RISK_SCORE",
    unit: "N/A",
    ParameterID: "GE2498",
    autoFetchKey: "N/A",
    referenceRange: "N/A",
    inputType: "Number",
    inputFieldType: "Input",
    subCategory: [],
    subTest: [],
    createdAt: "2025-11-14T16:16:10.214Z",
    updatedAt: "2025-11-14T16:16:10.214Z",
    __v: 0,
    result: "",
  },
  {
    _id: "691755caaae85ffdbee92068",
    name: "RISK",
    unit: "N/A",
    ParameterID: "GE5694",
    autoFetchKey: "N/A",
    referenceRange: "N/A",
    inputType: "Text",
    inputFieldType: "Input",
    subCategory: [],
    subTest: [],
    createdAt: "2025-11-14T16:16:10.485Z",
    updatedAt: "2025-11-14T16:16:10.485Z",
    __v: 0,
    result: "",
  },
  {
    _id: "691755caaae85ffdbee9206e",
    name: "COPD_SUMMARY",
    unit: "N/A",
    ParameterID: "GE9357",
    autoFetchKey: "N/A",
    referenceRange: "N/A",
    inputType: "Text",
    inputFieldType: "Input",
    subCategory: [],
    subTest: [],
    createdAt: "2025-11-14T16:16:10.677Z",
    updatedAt: "2025-11-14T16:16:10.677Z",
    __v: 0,
    result: "",
  },
  {
    _id: "691755caaae85ffdbee92076",
    name: "TB_RISKSCORE",
    unit: "N/A",
    ParameterID: "GE0399",
    autoFetchKey: "N/A",
    referenceRange: "N/A",
    inputType: "Text",
    inputFieldType: "Input",
    subCategory: [],
    subTest: [],
    createdAt: "2025-11-14T16:16:10.966Z",
    updatedAt: "2025-11-14T16:16:10.966Z",
    __v: 0,
    result: "",
  },
  {
    _id: "691755cbaae85ffdbee9207c",
    name: "ASTHMA_RISK_SCORE",
    unit: "N/A",
    ParameterID: "GE4914",
    autoFetchKey: "N/A",
    referenceRange: "N/A",
    inputType: "Number",
    inputFieldType: "Input",
    subCategory: [],
    subTest: [],
    createdAt: "2025-11-14T16:16:11.207Z",
    updatedAt: "2025-11-14T16:16:11.207Z",
    __v: 0,
    result: "",
  },
  {
    _id: "691755caaae85ffdbee92062",
    name: "STATUS",
    unit: "N/A",
    ParameterID: "GE8523",
    autoFetchKey: "N/A",
    referenceRange: "N/A",
    inputType: "Text",
    inputFieldType: "Input",
    subCategory: [],
    subTest: [],
    createdAt: "2025-11-14T16:16:10.289Z",
    updatedAt: "2025-11-14T16:16:10.289Z",
    __v: 0,
    result: "",
  },
  {
    _id: "691755caaae85ffdbee9206a",
    name: "COPD_LIKELY",
    unit: "N/A",
    ParameterID: "GE8161",
    autoFetchKey: "N/A",
    referenceRange: "N/A",
    inputType: "Text",
    inputFieldType: "Input",
    subCategory: [],
    subTest: [],
    createdAt: "2025-11-14T16:16:10.547Z",
    updatedAt: "2025-11-14T16:16:10.547Z",
    __v: 0,
    result: "",
  },
  {
    _id: "691755caaae85ffdbee92070",
    name: "COPD_SEVERITY",
    unit: "N/A",
    ParameterID: "GE6942",
    autoFetchKey: "N/A",
    referenceRange: "N/A",
    inputType: "Text",
    inputFieldType: "Input",
    subCategory: [],
    subTest: [],
    createdAt: "2025-11-14T16:16:10.749Z",
    updatedAt: "2025-11-14T16:16:10.749Z",
    __v: 0,
    result: "",
  },
  {
    _id: "691755cbaae85ffdbee92078",
    name: "TB_SUMMARY",
    unit: "N/A",
    ParameterID: "GE3903",
    autoFetchKey: "N/A",
    referenceRange: "N/A",
    inputType: "Text",
    inputFieldType: "Input",
    subCategory: [],
    subTest: [],
    createdAt: "2025-11-14T16:16:11.057Z",
    updatedAt: "2025-11-14T16:16:11.057Z",
    __v: 0,
    result: "",
  },
  {
    _id: "691755cbaae85ffdbee9207e",
    name: "ASTHMA_SUMMARY",
    unit: "N/A",
    ParameterID: "GE6483",
    autoFetchKey: "N/A",
    referenceRange: "N/A",
    inputType: "Text",
    inputFieldType: "Input",
    subCategory: [],
    subTest: [],
    createdAt: "2025-11-14T16:16:11.267Z",
    updatedAt: "2025-11-14T16:16:11.267Z",
    __v: 0,
    result: "",
  },
  {
    _id: "691755caaae85ffdbee92064",
    name: "COUGH_PATTERN",
    unit: "N/A",
    ParameterID: "GE4000",
    autoFetchKey: "N/A",
    referenceRange: "N/A",
    inputType: "Text",
    inputFieldType: "Input",
    subCategory: [],
    subTest: [],
    createdAt: "2025-11-14T16:16:10.350Z",
    updatedAt: "2025-11-14T16:16:10.350Z",
    __v: 0,
    result: "",
  },
  {
    _id: "691755caaae85ffdbee92072",
    name: "COPD_RISK_SCORE",
    unit: "N/A",
    ParameterID: "GE3153",
    autoFetchKey: "N/A",
    referenceRange: "N/A",
    inputType: "Number",
    inputFieldType: "Input",
    subCategory: [],
    subTest: [],
    createdAt: "2025-11-14T16:16:10.819Z",
    updatedAt: "2025-11-14T16:16:10.819Z",
    __v: 0,
    result: "",
  },
  {
    _id: "691755cbaae85ffdbee92080",
    name: "LHI",
    unit: "N/A",
    ParameterID: "GE9503",
    autoFetchKey: "N/A",
    referenceRange: "N/A",
    inputType: "Number",
    inputFieldType: "Input",
    subCategory: [],
    subTest: [],
    createdAt: "2025-11-14T16:16:11.328Z",
    updatedAt: "2025-11-14T16:16:11.328Z",
    __v: 0,
    result: "",
  },
  {
    _id: "691755caaae85ffdbee9205e",
    name: "TB_LIKELY",
    unit: "N/A",
    ParameterID: "GE9223",
    autoFetchKey: "N/A",
    referenceRange: "N/A",
    inputType: "Text",
    inputFieldType: "Input",
    subCategory: [],
    subTest: [],
    createdAt: "2025-11-14T16:16:10.140Z",
    updatedAt: "2025-11-14T16:16:10.140Z",
    __v: 0,
    result: "",
  },
  {
    _id: "691755caaae85ffdbee92066",
    name: "WET_COUGH_COUNT",
    unit: "N/A",
    ParameterID: "GE2800",
    autoFetchKey: "N/A",
    referenceRange: "N/A",
    inputType: "Number",
    inputFieldType: "Input",
    subCategory: [],
    subTest: [],
    createdAt: "2025-11-14T16:16:10.413Z",
    updatedAt: "2025-11-14T16:16:10.413Z",
    __v: 0,
    result: "",
  },
  {
    _id: "691755caaae85ffdbee9206c",
    name: "DRY_COUGH_COUNT",
    unit: "N/A",
    ParameterID: "GE9782",
    autoFetchKey: "N/A",
    referenceRange: "N/A",
    inputType: "Number",
    inputFieldType: "Input",
    subCategory: [],
    subTest: [],
    createdAt: "2025-11-14T16:16:10.609Z",
    updatedAt: "2025-11-14T16:16:10.609Z",
    __v: 0,
    result: "",
  },
  {
    _id: "691755caaae85ffdbee92074",
    name: "TB_RISK",
    unit: "N/A",
    ParameterID: "GE4761",
    autoFetchKey: "N/A",
    referenceRange: "N/A",
    inputType: "Number",
    inputFieldType: "Input",
    subCategory: [],
    subTest: [],
    createdAt: "2025-11-14T16:16:10.892Z",
    updatedAt: "2025-11-14T16:16:10.892Z",
    __v: 0,
    result: "",
  },
  {
    _id: "691755cbaae85ffdbee9207a",
    name: "ASTHMA_SEVERITY",
    unit: "N/A",
    ParameterID: "GE6172",
    autoFetchKey: "N/A",
    referenceRange: "N/A",
    inputType: "Text",
    inputFieldType: "Input",
    subCategory: [],
    subTest: [],
    createdAt: "2025-11-14T16:16:11.141Z",
    updatedAt: "2025-11-14T16:16:11.141Z",
    __v: 0,
    result: "",
  },
];

const buildCoughTestGroupPayload = (includeTbParams = true) => [
  {
    name: "Cough Analysis",
    groupName: "Cough Analysis",
    options: subfield2
      .filter((option) =>
        includeTbParams ? true : !TB_PARAMETER_IDS.has(option.ParameterID)
      )
      .map((option) => ({
        ...option,
        result: option.result ?? "",
        subCategory: Array.isArray(option.subCategory)
          ? option.subCategory.map((sub) => ({ ...sub }))
          : [],
        subTest: Array.isArray(option.subTest)
          ? option.subTest.map((sub) => ({ ...sub }))
          : [],
      })),
  },
];



const subFields = [
  {
    fieldId: "",
    fieldName: "Dry Cough Count",
    fieldObjectName: "dry_cough_count",
    ParameterID: "GE9782",
    unitAndRange: "",
    value: "",
  },
  {
    fieldId: "",
    fieldName: "Wet Cough Count",
    fieldObjectName: "wet_cough_count",
    ParameterID: "GE2800",
    unitAndRange: "",
    value: "",
  },
  {
    fieldId: "",
    fieldName: "TB Likely",
    fieldObjectName: "tb_likely",
    ParameterID: "GE9223",
    unitAndRange: "",
    value: "",
  },
  {
    fieldId: "",
    fieldName: "TB Risk",
    fieldObjectName: "tb_Risk",
    ParameterID: "GE4761",
    unitAndRange: "",
    value: "",
  },
  {
    fieldId: "",
    fieldName: "TB Risk Score",
    fieldObjectName: "tb_RiskScore",
    ParameterID: "GE0399",
    unitAndRange: "",
    value: "",
  },
  {
    fieldId: "",
    fieldName: "TB Summary",
    fieldObjectName: "tb_Summary",
    ParameterID: "GE3903",
    unitAndRange: "",
    value: "",
  },
  {
    fieldId: "",
    fieldName: "COPD Summary",
    fieldObjectName: "COPD_Summary",
    ParameterID: "GE9357",
    unitAndRange: "",
    value: "",
  },
  {
    fieldId: "",
    fieldName: "COPD Risk Score",
    fieldObjectName: "COPD_risk_score",
    ParameterID: "GE3153",
    unitAndRange: "",
    value: "",
  },
  {
    fieldId: "",
    fieldName: "Asthma Risk Score",
    fieldObjectName: "asthma_risk_score",
    ParameterID: "GE4914",
    unitAndRange: "",
    value: "",
  },
  {
    fieldId: "",
    fieldName: "Asthma Severity",
    fieldObjectName: "asthma_severity",
    ParameterID: "GE6172",
    unitAndRange: "",
    value: "",
  },
  {
    fieldId: "",
    fieldName: "Cough Risk Score",
    fieldObjectName: "cough_risk_score",
    ParameterID: "GE2498",
    unitAndRange: "",
    value: "",
  },
  {
    fieldId: "",
    fieldName: "Cough Pattern",
    fieldObjectName: "cough_pattern",
    ParameterID: "GE4000",
    unitAndRange: "",
    value: "",
  },
  {
    fieldId: "",
    fieldName: "Risk",
    fieldObjectName: "risk",
    ParameterID: "GE5694",
    unitAndRange: "",
    value: "",
  },
  {
    fieldId: "",
    fieldName: "COPD Likely",
    fieldObjectName: "COPD_likely",
    ParameterID: "GE8161",
    unitAndRange: "",
    value: "",
  },
  {
    fieldId: "",
    fieldName: "COPD Severity",
    fieldObjectName: "COPD_severity",
    ParameterID: "GE6942",
    unitAndRange: "",
    value: "",
  },
  {
    fieldId: "",
    fieldName: "Asthma Summary",
    fieldObjectName: "asthma_Summary",
    ParameterID: "GE6483",
    unitAndRange: "",
    value: "",
  },
  {
    fieldId: "",
    fieldName: "LHI",
    fieldObjectName: "lhi",
    ParameterID: "GE9503",
    unitAndRange: "",
    value: "",
  },
];

export default function TestParameter() {
  const patientDetails = useSelector((state) => state.patientSlice.patientData);
  const referedByFromStore = useSelector(
    (state) => state.testSlice.referedBy || ""
  );

  const dispatch = useDispatch();
  const [apiResponse, setApiResponse] = useState({});
  const response = useRiskScoreAssessment();
  const [showTbDetails, setShowTbDetails] = useState(false);
  const [riskError, setRiskError] = useState(null);

  const shouldRenderKey = (key = "") => {
    const normalized = key.toLowerCase();
    if (EXCLUDED_KEYS.has(normalized)) return false;
    if (!showTbDetails && TB_FIELD_KEYS.has(normalized)) return false;
    return true;
  };

  // 🔹 Build tests config for useGeneralTestLogic
  const testsConfig = useMemo(
    () => [
      {
        testCode: "COUGH_ASSESSMENT", // any identifier you like
        options: subFields.map((sf) => ({
          ParameterID: sf.ParameterID,
          result: "", // will be overridden by API response below
        })),
      },
    ],
    []
  );

  // 🔹 Use the general test logic hook
  const {
    referredBy,
    setReferredBy,
    handleResultChange,
    saveResults,
    saveReferredBy,
  } = useGeneralTestLogic(testsConfig, referedByFromStore);

  useEffect(() => {
    if (!response || !response.status) return;

    const httpOk = response.status === 200;
    const payloadData = { ...(response.data?.data || {}) };
    const apiStatus = response.data?.status || payloadData?.status;

    if (!httpOk || apiStatus === "ERROR") {
      const message =
        payloadData?.message ||
        response.statusText ||
        "Unable to fetch cough assessment.";
      setRiskError(message);
      setApiResponse({});
      return;
    }

    setRiskError(null);
    const normalizedPayload = { ...payloadData };
    const assessmentId = response.data?.assessmentId;
    if (assessmentId) {
      normalizedPayload.assessmentId = assessmentId;
    }

    // remove height / weight from display payload
    delete normalizedPayload.height;
    delete normalizedPayload.weight;

    // remove excluded keys
    Object.keys(normalizedPayload).forEach((key) => {
      if (EXCLUDED_KEYS.has(key.toLowerCase())) {
        delete normalizedPayload[key];
      }
    });

    setApiResponse(normalizedPayload);

    // 🔹 ALSO push values into the generic hook as ParameterID -> value
    subFields.forEach((subField) => {
      const rawValue = normalizedPayload[subField.fieldObjectName];
      const value =
        subField.fieldName === "Wet Cough Count"
          ? "0"
          : rawValue ?? subField.value ?? "";
      if (subField.ParameterID) {
        // ensure string always
        const strValue =
          value === null || value === undefined ? "" : String(value);
        handleResultChange(subField.ParameterID, strValue);
      }
    });
  }, [response, handleResultChange]);

  const responseEntries = Object.entries(apiResponse || {})
    .map(([key, value], index) => ({ key, value, index }))
    .filter(({ key }) => shouldRenderKey(key || ""))
    .sort((a, b) => {
      const normA = a.key.toLowerCase();
      const normB = b.key.toLowerCase();
      const aTbIndex = TB_DISPLAY_ORDER.indexOf(normA);
      const bTbIndex = TB_DISPLAY_ORDER.indexOf(normB);
      const aWeight = aTbIndex !== -1 ? aTbIndex : TB_DISPLAY_ORDER.length + a.index;
      const bWeight = bTbIndex !== -1 ? bTbIndex : TB_DISPLAY_ORDER.length + b.index;
      return aWeight - bWeight;
    })
    .map(({ key, value }) => [key, value]);

    const handleGenerateReport = (e) => {
      e.preventDefault();
    
      // 1) store layout / structure for PDF (tests + subFields)
      //    If showTbDetails is false, TB params are excluded
      dispatch(addTests(buildCoughTestGroupPayload(showTbDetails)));
    
      // 2) store referredBy via generic hook
      saveReferredBy();
    
      // 3) store ParameterID -> value map AND navigate to /tests/testId/report
      saveResults({ redirectToReport: true });
    };
    
  return (
    <div
      className="test-parameter w-full flex justify-center"
      style={{ fontFamily: "poppins" }}
    >
      <form
        onSubmit={handleGenerateReport}
        className="w-4/5 bg-white mt-20 mb-10 rounded-lg shadow-sm"
      >
        <div className="grid grid-cols-4 bg-purple-600 text-white text-sm py-4 px-4 rounded-t-lg">
          <div className="font-medium">TEST CATEGORY</div>
          <div className="font-medium">TEST NAME</div>
          <div className="font-medium">RESULTS</div>
          <div className="font-medium">UNIT & RANGE</div>
        </div>

        {riskError && (
          <div className="m-4 rounded bg-red-50 px-4 py-3 text-sm text-red-700">
            {riskError}
          </div>
        )}

        <div className="flex justify-end px-4 pt-2">
          <button
            type="button"
            onClick={() => setShowTbDetails((prev) => !prev)}
            className="rounded bg-purple-100 px-3 py-1 text-sm font-medium text-purple-700 border border-purple-700 transition hover:bg-purple-200"
          >
            {showTbDetails ? "Hide TB Parameters" : "View TB Parameters"}
          </button>
        </div>

        <div className="p-4">
          <table className="w-full border-separate border-spacing-0">
            <tbody>
              {responseEntries.map(([key, value]) => (
                <tr key={key} className="border-b border-blue-100">
                  <td className="text-purple-600 py-2 w-1/4 pl-4">
                    {key.toUpperCase()}
                  </td>
                  <td className="py-2 px-4">
                    <input
                      disabled
                      type="text"
                      name={key}
                      value={
                        key === "patientId"
                          ? patientDetails?.PatientID
                          : value
                      }
                      className="h-8 w-full px-3 rounded bg-purple-100 focus:bg-purple-50 focus:outline-none focus:ring-1 focus:ring-purple-400"
                      placeholder={`Enter ${key}`}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="flex items-center justify-between pt-6 mt-4 border-t border-gray-200">
          <div className="flex items-center mx-4 gap-4">
            <span className="text-purple-600">REFERRED BY:</span>
            <input
              type="text"
              name="referredBy"
              value={referredBy}
              onChange={(e) => setReferredBy(e.target.value)}
              className="w-48 h-8 px-3 rounded bg-purple-100 focus:bg-purple-50 focus:outline-none focus:ring-1 focus:ring-purple-400"
              placeholder="Enter name"
            />
          </div>
          <button
            type="submit"
            style={{ backgroundColor: "#6B46C1" }}
            className="m-4 text-white font-bold py-2 px-4 rounded"
          >
            GENERATE REPORT
          </button>
        </div>
      </form>
    </div>
  );
}
